import { IPhone } from '../types/newbuilding/phone';

export const isCorrectPhoneObject = (phone?: IPhone | null): boolean => {
  return !!(phone && phone.countryCode && phone.code && phone.number);
};
